import { Breadcrumb, Breadcrumbs, SxProps } from '@cast/design-system';
import { usePath } from '@cast/utils';

import { Link } from 'components/router';

import { makeWorkloadsCostMonitoringLink } from '../../links';

type Props = {
  workloadName: string;
  sx?: SxProps;
};

export const WorkloadDetailsBreadcrumbs = ({ workloadName, sx }: Props) => {
  return (
    <Breadcrumbs sx={sx}>
      <Breadcrumb>
        <Link
          to={usePath(makeWorkloadsCostMonitoringLink)}
          style={{ color: 'inherit', textDecoration: 'inherit' }}
        >
          Workloads
        </Link>
      </Breadcrumb>
      <Breadcrumb>{workloadName}</Breadcrumb>
    </Breadcrumbs>
  );
};
